import React from "react";
import styles from "../SubjectSinglePage.module.css";
import { buildSubjectDescription } from "../model/subjectSingleModel";
import type { SubjectItem, SubjectStats } from "../model/types";

type SubjectHeroProps = {
  subject: SubjectItem;
  stats: SubjectStats;
  onBackToSubject: () => void;
  onBranchGistsClick?: () => void;
};

export function SubjectHero({
  subject,
  stats,
  onBackToSubject,
  onBranchGistsClick,
}: SubjectHeroProps) {
  return (
    <section
      className={styles.heroPanel}
      aria-labelledby="subject-single-title"
    >
      <div className={styles.heroIcon} aria-hidden="true">
        <span />
      </div>
      <div className={styles.heroCopy}>
        <h1 id="subject-single-title">{subject.title}</h1>
        <p>{buildSubjectDescription(subject, stats)}</p>
        <div className={styles.statRow} aria-label="Subject metrics">
          {onBranchGistsClick ? (
            <button
              type="button"
              className={styles.statButton}
              onClick={onBranchGistsClick}
            >
              {stats.branchGistCount} gists in branch
            </button>
          ) : (
            <span>{stats.branchGistCount} gists in branch</span>
          )}
          <span>{stats.childCount} direct child subjects</span>
          <span>{stats.commentCount} visible comments</span>
          <span>{stats.editCount} edits</span>
        </div>
      </div>
      <button
        type="button"
        className={styles.subjectLink}
        onClick={onBackToSubject}
      >
        Back to subject
      </button>
    </section>
  );
}
